export const dynamicSubmitMessage = [
  'Iniciando processo de busca',
  'Aguarde mais alguns segundos',
  'Separando os melhores profissionais',
];
